import { Switch, Route } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { announcementsRoutes } from './allRoutes';
import { BACKOFFICE_MODULES } from 'types/configuration.types';

const switchRoutes = (
  <Switch>
    {announcementsRoutes.map((prop, key) => {
      if (prop.layout === BACKOFFICE_MODULES.ANNOUNCEMENT) {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
  </Switch>
);

const Announcements = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default Announcements;

